import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { DayTripPlanDefault_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
	planID: string;
};

export const useDayTripPlanEditQuery = ({ hotelID, planID }: Props) => {
	const { data } = useCustomSuspenseQuery(DayTripPlanDefault_EditPage_Query, {
		variables: { hotelID, planID },
	});

	return data;
};
